'use strict';

import { AppDispatcher } from 'dispatcher';
import * as constants from 'vd-constants';

export default {
  visitPage(payload) {
    AppDispatcher.dispatch(constants.VISIT_PAGE, {
      payload,
    });
  },
};
